import React, { useState } from 'react'
import { Modal, Form, Input, Button } from 'antd'
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import { userinfoService } from '@/common/services/userinfo/userinfoService'

interface ModalChangePasswordProps {
	visible: boolean
	onCancel: () => void
	onOk: (val: any) => void
}

const ModalChangePassword: React.FC<ModalChangePasswordProps> = ({
	visible,
	onCancel,
	onOk
}) => {
	const [useInfo] = useAtomMethod(userinfoService.userInfo)
	const [form] = Form.useForm()

	const handleCancel = () => {
		onCancel()
		form.resetFields()
	}
	const handleOk = () => {
		form.validateFields().then((values) => {
			onOk({ ...values })
			form.resetFields()
		}).catch((err) => {
			console.warn('修改密码表单校验失败');
		})
	}

	return (
		<Modal
			title="设置密码"
			open={visible}
			onCancel={handleCancel}
			onOk={handleOk}
			// destroyOnClose
		>
			<Form form={form} layout="vertical">
				{useInfo?.isPassword ? (
					<Form.Item
						name="oldPassword"
						label="原密码"
						rules={[{ required: true, message: '请输入原密码!' }]}
					>
						<Input.Password />
					</Form.Item>
				) : (
					''
				)}
				<Form.Item
					name="newPassword"
					label="新密码"
					rules={[{ required: true, message: '请输入新密码!' }]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item
					name="confirmPassword"
					label="确认密码"
					dependencies={['newPassword']}
					rules={[
						{
							required: true,
							message: '请确认新密码!'
						},
						({ getFieldValue }) => ({
							validator(rule, value) {
								if (!value || getFieldValue('newPassword') === value) {
									return Promise.resolve()
								}
								return Promise.reject('确认密码与新密码不一致!')
							}
						})
					]}
				>
					<Input.Password />
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default ModalChangePassword
